var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__title" }, [
        _c("h5", [_vm._v("Información de la consulta")]),
        _vm._v(" "),
        _c("div", { staticClass: "card__controls" }, [
          _c(
            "button",
            {
              staticClass: "btn-info",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _c("span", [_vm._v("Consultar")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "tipo_fecha",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "P" } }, [
                      _vm._v("Personalizado")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipo_fecha" } }, [
                  _vm._v("Tipo de fecha")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "col-xs-12 col-md-4"
            },
            [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "fecha",
                        locale: "es",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        "only-date": "",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.desde,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "desde", $$v)
                        },
                        expression: "form.desde"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Desde")])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "col-xs-12 col-md-4"
            },
            [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "fecha",
                        locale: "es",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        "only-date": "",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.hasta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "hasta", $$v)
                        },
                        expression: "form.hasta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Hasta")])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      options: _vm.recaudadores,
                      label: "nombre",
                      placeholder: "Seleccione...",
                      id: "recaudador"
                    },
                    on: {
                      input: _vm.inputRecaudadores,
                      search: _vm.searchRecaudadores
                    },
                    model: {
                      value: _vm.selectedRecaudador,
                      callback: function($$v) {
                        _vm.selectedRecaudador = $$v
                      },
                      expression: "selectedRecaudador"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "recaudador" } }, [
                    _vm._v("Recaudador(es)")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      label: "descripcion",
                      multiple: "",
                      options: _vm.rutas,
                      placeholder: "Seleccione...",
                      id: "ruta"
                    },
                    on: { input: _vm.inputRutas, search: _vm.onSearchRutas },
                    model: {
                      value: _vm.selectedRutas,
                      callback: function($$v) {
                        _vm.selectedRutas = $$v
                      },
                      expression: "selectedRutas"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "ruta" } }, [_vm._v("Ruta(s)")])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.dia_cobro,
                        expression: "form.dia_cobro"
                      }
                    ],
                    attrs: { name: "dia_cobro", id: "dia_cobro" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "dia_cobro",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { disabled: "", value: "" } }, [
                      _vm._v("Seleccione...")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "1" } }, [_vm._v("Lunes")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "2" } }, [_vm._v("Martes")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "3" } }, [
                      _vm._v("Miércoles")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "4" } }, [_vm._v("Jueves")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "5" } }, [
                      _vm._v("Viernes")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "6" } }, [_vm._v("Sábado")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "7" } }, [_vm._v("Domingo")])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "dia_cobro" } }, [
                  _vm._v("Día de cobro")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "bodega",
                      placeholder: "Seleccione...",
                      options: _vm.bodegas,
                      label: "descripcion"
                    },
                    on: { input: _vm.inputBodega },
                    model: {
                      value: _vm.selectedBodega,
                      callback: function($$v) {
                        _vm.selectedBodega = $$v
                      },
                      expression: "selectedBodega"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "bodega" } }, [
                    _vm._v("Sucursal")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "estado",
                      placeholder: "Seleccione...",
                      options: _vm.estados,
                      label: "descripcion"
                    },
                    model: {
                      value: _vm.selectedEstado,
                      callback: function($$v) {
                        _vm.selectedEstado = $$v
                      },
                      expression: "selectedEstado"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "estado" } }, [_vm._v("Estado")])
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card mt-2" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c(
          "div",
          { staticStyle: { height: "700px" } },
          [
            _c(
              "l-map",
              {
                ref: "mymap",
                staticStyle: { height: "100%", width: "100%" },
                attrs: { zoom: _vm.zoom, center: _vm.center },
                on: {
                  "update:zoom": _vm.zoomUpdated,
                  "update:center": _vm.centerUpdated
                }
              },
              [
                _c("l-tile-layer", { attrs: { url: _vm.url } }),
                _vm._v(" "),
                _vm._l(_vm.recaudaciones_filter, function(recaudacion, index) {
                  return _c(
                    "l-marker",
                    {
                      key: "recaudacion" + index,
                      attrs: {
                        name: recaudacion.id,
                        icon: recaudacion.icon,
                        "lat-lng": [
                          parseFloat(recaudacion.latitud),
                          parseFloat(recaudacion.longitud)
                        ]
                      }
                    },
                    [
                      _c(
                        "l-tooltip",
                        { attrs: { options: _vm.tooltipOptions } },
                        [_vm._v("(" + _vm._s(recaudacion.indice) + ")")]
                      ),
                      _vm._v(" "),
                      _c("l-popup", [
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("Recaudador:")]),
                            _vm._v(" " + _vm._s(recaudacion.nombre_recaudador))
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Cliente:")]),
                            _vm._v(
                              " " + _vm._s(recaudacion.cliente.descripcion)
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Venta:")]),
                            _vm._v(" " + _vm._s(recaudacion.numero_documento))
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Ruta:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  recaudacion.ruta != null
                                    ? recaudacion.ruta.nombre
                                    : "N/A"
                                )
                            )
                          ]),
                          _vm._v(" "),
                          recaudacion.abono != null
                            ? _c("li", [
                                _c("strong", [_vm._v("Fecha:")]),
                                _vm._v(
                                  " " + _vm._s(recaudacion.abono.fecha_abono)
                                )
                              ])
                            : _vm._e(),
                          _c("li", [
                            _c("strong", [_vm._v("Cliente:")]),
                            _vm._v(
                              " " + _vm._s(recaudacion.cliente.descripcion)
                            )
                          ]),
                          _vm._v(" "),
                          recaudacion.abono != null
                            ? _c("li", [
                                _c("strong", [_vm._v("Valor:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.moneyFormat(
                                        recaudacion.abono.valor_abono
                                      )
                                    )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Saldo:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.moneyFormat(recaudacion.saldo_total))
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.polylines, function(polyline, index) {
                  return _c("l-polyline", {
                    key: index + polyline.color,
                    attrs: {
                      weight: 7,
                      "lat-lngs": polyline.latlngs,
                      color: polyline.color
                    }
                  })
                }),
                _vm._v(" "),
                _vm._l(_vm.polylines, function(polyline, index) {
                  return _c("l-polyline", {
                    key: index,
                    attrs: {
                      weight: 2,
                      "lat-lngs": polyline.latlngs,
                      color: "white"
                    }
                  })
                })
              ],
              2
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(2)
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "card mt-2" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c(
              "div",
              {
                staticClass: "table-responsive",
                staticStyle: { "max-height": "300px" }
              },
              [
                _c("table", [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.comentarios, function(comentario) {
                        return _c("tr", { key: comentario.id }, [
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(comentario.venta.numero_documento) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(comentario.usuario.nombre) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(comentario.comentario) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(comentario.fecha_comentario) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      comentario.coordenadas_comentario != null,
                                    expression:
                                      "comentario.coordenadas_comentario != null"
                                  }
                                ],
                                staticClass: "btn-info btn--text",
                                on: {
                                  click: function($event) {
                                    return _vm.verDireccion(comentario)
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-map-marker" }),
                                _c("span", [
                                  _vm._v(_vm._s(comentario.direccion))
                                ])
                              ]
                            )
                          ])
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.comentarios.length === 0,
                              expression: "comentarios.length === 0"
                            }
                          ]
                        },
                        [_vm._m(5)]
                      )
                    ],
                    2
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Recaudación")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Mapa")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c("img", {
            attrs: { src: "/images/dias-cobro/1-sm.png", alt: "Lunes" }
          }),
          _c("label", { attrs: { for: "lunes" } }, [_vm._v("Pendientes")]),
          _vm._v(" "),
          _c("img", {
            attrs: { src: "/images/dias-cobro/5-sm.png", alt: "Cobradas" }
          }),
          _c("label", { attrs: { for: "cobradas" } }, [_vm._v("Cobradas")]),
          _vm._v(" "),
          _c("img", {
            attrs: { src: "/images/dias-cobro/7-sm.png", alt: "No cobradas" }
          }),
          _c("label", { attrs: { for: "no_cobradas" } }, [
            _vm._v("No cobradas")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Comentarios")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Venta")]),
        _vm._v(" "),
        _c("th", [_vm._v("Usuario")]),
        _vm._v(" "),
        _c("th", [_vm._v("Comentario")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de comentario")]),
        _vm._v(" "),
        _c("th", [_vm._v("Dirección")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("strong", [_vm._v("No se ha encontrado comentarios.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-425de4c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425de4c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/DashboardRecaudaciones.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-425de4c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/DashboardRecaudaciones.vue
// module chunks = 0